module.exports = __webpack_public_path__ + "assets/twitter.32b01a6c.svg";